import { DecimalPipe } from '@angular/common';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'checknan',
})
export class ChecknanPipe {
  transform(value: number): any {
    if (isNaN(value) === false) {
      return value;
    }
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/checknan.pipe.ts